var Do = function(){
    
    var _ajax = function(route,packet,withHeaders){
    
        if( withHeaders !== false ){
    
            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });
    
        }
    
        $.ajax({
            url:        route,
            type:       typeof packet._method == 'undefined' ? 'POST' : packet._method,
            cache:      false,
            dataType:   'json',
            data:       packet,
            success:    function(returned){
                msg = returned.action.message;
                if( returned.outcome=='FAIL'){
                    Do.Callback( msg.callback, msg.with );
                    if(typeof returned.action.route !== "undefined"){
                        setTimeout(function(){  window.location.href=returned.action.route; }, msg.with.delay);
                    }
                }
                if( returned.outcome=='PASS'){
                    if(msg.callback.length){
                        Do.Callback( msg.callback, msg.with );
                    }
                    if(typeof returned.action.route !== 'undefined'){
                        setTimeout(function(){  window.location.href=returned.action.route; }, msg.with.delay);
                    }
                }
            },
            error: function(data){
                returned = data.responseJSON;
                var content;
                $.each( returned.errors, function( key, value ) {
                    $('#error-'+key).html('<span class="form-text text-danger"><i class="icon-cancel-circle2 mr-2"></i>'+value[0]+'</span>');
                    content = value[0];
                });
                alert( content );
            }
        });
    }

    var _callback = function( callback, args ){
        if(Array.isArray(callback)){
            Debug.log('preparing Array callback',callback);
            var instance = this[callback[0]];
            var method = callback[1];
            return instance[method](args);
           
        }else{
            Debug.log('preparing String callback ',callback);
            return this[callback](args);
        }
    }

    var _notyfi = function(args){
        new Noty({
                theme: ' alert alert-'+args.class+' alert-styled-left p-0 bg-white',
                layout: 'center',
                text: args.content,
                type: args.class,
                progressBar: true,
                timeout: args.delay
        }).show();
        Debug.log('Utils.Notify()',args);
    }

    return {
        Ajax: function(r,p,h){
            _ajax(r,p,h)
        },
        Callback: function(c,a){
            _callback(c,a);
        },
        Notify: function(a){
            _notyfi(a);
        },
        GetUser: function(r){
            _getUser(r);
        }
    }
}();


var notyfi = function(args){
    Do.Notify(args);
}